<ng-container
  *ngIf="canSubmitSuperBills && (patient$ | async)"
  [templateStore]="{
    patientInfo: (patient$ | async),
    patientCreditCards: (patientCreditCards$ | async),
    canUseProBonoNpc: (canUseProBonoNpc$ | async),
    isLoading: (isLoading$ | async)
  }"
  #clientStore="templateStore"
>
  <section class="header" data-dd-privacy="allow">
    <div class="header-left">
      <p class="helper-text">
        <iris-icon name="info_outline"></iris-icon>
        Clients will see changes you make to their payment information.
      </p>
    </div>
  </section>
  <iris-card *ngIf="clientStore.patientInfo?.haveClientRecord && clientStore.canUseProBonoNpc">
    <div class="card-header" data-dd-privacy="allow">
      <h2 class="card-heading" data-test="pro-bonos">Complimentary therapy sessions</h2>
      <iris-icon-button
        ariaLabel="Gift complimentary sessions"
        (click)="addProBono()"
        icon="plus"
        [type]="IrisIconButtonTypes.TERTIARY"
      ></iris-icon-button>
    </div>
    <section class="pro-bono-container">
      <header data-dd-privacy="allow">Complimentary Sessions</header>
      <main class="credits">{{ usedProBono }} Used, {{ remainingProBono }} Remaining</main>
    </section>
  </iris-card>
  <br *ngIf="clientStore.patientInfo?.haveClientRecord && clientStore.canUseProBonoNpc">

  <iris-card>
    <div class="card-header" data-dd-privacy="allow">
      <h2 data-test="credit-cards" class="card-heading">Credit cards</h2>
      <iris-icon-button
        ariaLabel="Add credit card"
        (click)="addCard()"
        icon="plus"
        [type]="IrisIconButtonTypes.TERTIARY"
        data-test="add-credit-card-button"
      ></iris-icon-button>
    </div>

    <div [hidden]="!clientStore.patientCreditCards?.length">
      <!-- ************** For Web View ************** -->
      <div class="hide-mobile">

        <mat-table
          #table
          [dataSource]="clientStore.patientCreditCards"
          data-test="credit-cards-table"
        >
          <ng-container matColumnDef="billing_contact" >
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Billing Contact</mat-header-cell>
            <mat-cell
              class="pad2"
              *matCellDef="let row"
              data-dd-action-name='contact name'
              data-dd-privacy="mask"
            >
                {{row.billingContact}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="brand">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Card Type</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.brand}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="last4">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Last 4 Digits</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.last4}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="exp_date">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Exp Date</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.expMonth}}/{{row.expYear}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="last_charged">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Last Charged</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              &nbsp;
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nickname">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Nickname</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.nickname}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >&nbsp;</mat-header-cell>
            <mat-cell
              class="pad2 text-right action-wrapper"
              *matCellDef="let row"
            >
              <ng-container *ngIf="clientCreditCardService.processingFor != row.id">
                <ng-container *ngIf="row.active == false && creditCardMenuItemsMap$ | async as menuItemsMap">
                  <iris-menu 
                    [menuItemList]="menuItemsMap.get(row.id)"
                    data-test="menu">
                  </iris-menu>
                </ng-container>
                <ng-container *ngIf="row.active == true">
                  <button mat-icon-button>
                    <iris-icon name="favorite" [size]="iconSizes.SM" colorToken="$color-dec-indigo-60"></iris-icon>
                  </button>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="clientCreditCardService.processingFor == row.id">
                <mat-spinner mat-icon-button [diameter]="30"> </mat-spinner>
              </ng-container>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="creditCardColumns"></mat-header-row>
          <mat-row data-test="credit-card" *matRowDef="let row; columns: creditCardColumns;"></mat-row>
        </mat-table>
      </div>

      <!-- ************** For Mobile View ************** -->
      <div class="show-mobile">
        <mat-table #table [dataSource]="clientStore.patientCreditCards">
          <ng-container matColumnDef="brand">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Card Type</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.brand}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="last4">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Last 4 Digits</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.last4}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="exp_date">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Exp Date</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.expMonth}}/{{row.expYear}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nickname">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >Nickname</mat-header-cell>
            <mat-cell class="pad2" *matCellDef="let row">
              {{row.nickname}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell
              class="pad2"
              *matHeaderCellDef
              disableClear="true"
            >&nbsp;</mat-header-cell>
            <mat-cell class="pad2 text-right block action-wrapper" *matCellDef="let row">
                <iris-menu 
                  data-test="menu"
                  [menuItemList]="(creditCardMenuItemsMapForMobile$ | async)?.get(row.id)"
                >
                </iris-menu>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="creditCardMobileColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: creditCardMobileColumns;"></mat-row>
        </mat-table>
      </div>
    </div>
    <div
      class="empty-state"
      *ngIf="!clientStore.isLoading && !clientStore.patientCreditCards?.length"
    >
      <iris-icon name="info" [size]="iconSizes.SM"></iris-icon>No records found !
    </div>
  </iris-card>
  <br>

  @if (!isSaasEnabled()) {
    <iris-card>
      <div class="card-header">
        <h2 data-test="insurance-providers" class="card-heading">Insurance providers</h2>
        <iris-icon-button
          *ngIf="!clientStore.isLoading && patient?.personaClientId"
          ariaLabel="Add insurance provider"
          (click)="addInsurance()"
          icon="plus"
          [type]="IrisIconButtonTypes.TERTIARY"
          data-test="add-insurance-button"
        ></iris-icon-button>
        <p *ngIf="!clientStore.isLoading && !patient?.personaClientId">Invite your patient to Client Portal to see their insurance information.</p>
      </div>

      <div [hidden]="!patientInsurances?.length">
        <!-- ************** For Web View ************** -->
        <div class="hide-mobile">
          <mat-table
            #table
            [dataSource]="patientInsurances"
            data-test="insurances-table"
          >
            <ng-container matColumnDef="provider_network">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Insurance</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.providerNetworkCompany.id | providerNetworkName : (pncLookup$ | async) }}
                <mat-basic-chip
                  class="mat-basic-chip-label mat-red-back marginLeft5"
                  *ngIf="row.deleted"
                  selectable="false"
                >Inactive</mat-basic-chip>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="policy_holder">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Policy Holder</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.insuranceInformation.firstName}} {{row.insuranceInformation.lastName}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="group_number">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Group Number</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.insuranceInformation.groupNumber}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="member_number">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Member Number</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.insuranceInformation.policyNumber}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="complimentary_sessions">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Complimentary Sessions</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                <ng-container *ngIf="row.providerNetworkCompany.redemption">
                  {{row.usedRedemptions}} Used, {{row.remainingRedemptions}} Remaining
                </ng-container>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >&nbsp;</mat-header-cell>
              <mat-cell class="pad2 text-right block action-wrapper" *matCellDef="let row">
                <ng-container *ngIf="!row.isUsageBased">
                  <iris-menu 
                    data-test="edit"
                    [menuItemList]="(insuranceMenuItemsMap$ | async)?.get(row.id)" 
                    >
                  </iris-menu>
                </ng-container>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="insuranceColumns"></mat-header-row>
            <mat-row data-test="insurance" *matRowDef="let row; columns: insuranceColumns;"></mat-row>
          </mat-table>
        </div>

        <!-- ************** For Mobile View ************** -->
        <div class="show-mobile">
          <mat-table #table [dataSource]="patientInsurances">
            <ng-container matColumnDef="provider_network">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Insurance</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                <div class="insurance-column">
                  <div>{{row.providerNetworkCompany.id | providerNetworkName : (pncLookup$ | async)}}</div>
                  <div>
                    <mat-basic-chip
                      class="mat-basic-chip-label mat-red-back"
                      *ngIf="row.deleted"
                      selectable="false"
                    >Inactive</mat-basic-chip>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="policy_holder">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Policy Holder</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.insuranceInformation.firstName}} {{row.insuranceInformation.lastName}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="member_number">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Member Number</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                {{row.insuranceInformation.policyNumber}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="complimentary_sessions">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >Complimentary Sessions</mat-header-cell>
              <mat-cell class="pad2" *matCellDef="let row">
                <ng-container *ngIf="row.providerNetworkCompany.redemption">
                  {{row.usedRedemptions}} Used, {{row.remainingRedemptions}} Remaining
                </ng-container>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell
                class="pad2"
                *matHeaderCellDef
                disableClear="true"
              >&nbsp;</mat-header-cell>
              <mat-cell class="pad2 text-right block action-wrapper" *matCellDef="let row">
                <ng-container *ngIf="!row.isUsageBased">
                  <iris-menu 
                    data-test="menu"
                    [menuItemList]="(insuranceMenuItemsMap$ | async)?.get(row.id)" 
                    >
                  </iris-menu>
                </ng-container>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="insuranceMobileColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: insuranceMobileColumns;"></mat-row>
          </mat-table>
        </div>
      </div>
      <div
        class="empty-state"
        *ngIf="!clientStore.isLoading && !patientInsurances?.length"
      >
        <iris-icon name="info" [size]="iconSizes.SM" colorToken="$color-dec-indigo-60"></iris-icon>No records found !
      </div>
    </iris-card>
  }

  <br>
  <member-va-authorizations-card
    [authorizations]="clientStore.patientInfo?.referralAuthorizations"
  ></member-va-authorizations-card>
</ng-container>


<client-patient-insurance-modal [patient]="patient"></client-patient-insurance-modal>
<sondermind-confirmation-modal></sondermind-confirmation-modal>
